module.exports = __webpack_public_path__ + "0218f29e61c6dacb39d3cde5c166fa7e.png";